import { render, staticRenderFns } from "./DeleteCompanyConfirmModal.vue?vue&type=template&id=2f699be5&"
import script from "./DeleteCompanyConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCompanyConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports